module.exports = __webpack_public_path__ + "static/media/h-icon.e7c92721.svg";